import { Tag } from "antd";
import { CheckCircle, Clock, RefreshCw } from "lucide-react";
import { GradingStatusEnum } from "../../types/grading/GradingStatus";
import { useTranslation } from "react-i18next";

interface Props {
  status: GradingStatusEnum;
  showIcon?: boolean;
}

/**
 * Reusable badge component for displaying grading status consistently across the app.
 */
export const GradingStatusBadge = ({ status, showIcon = true }: Props) => {
  const { t } = useTranslation();

  const getStatusConfig = () => {
    switch (status) {
      case GradingStatusEnum.NotStarted:
        return {
          color: "default",
          icon: <Clock size={14} />,
          label: t("grading.status.notStarted"),
        };
      case GradingStatusEnum.InProgress:
        return {
          color: "processing",
          icon: <RefreshCw size={14} />,
          label: t("grading.status.inProgress"),
        };
      case GradingStatusEnum.Complete:
        return {
          color: "success",
          icon: <CheckCircle size={14} />,
          label: t("grading.status.complete"),
        };
      default:
        return {
          color: "default",
          icon: <Clock size={14} />,
          label: t("grading.status.unknown"),
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Tag 
      color={config.color}
      icon={showIcon ? config.icon : undefined}
      style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
    >
      {config.label}
    </Tag>
  );
};
